interface FmtpErrorArgs {
    errorCode?: FmtpErrorCode;
    message: string;
}

export type FmtpErrorCode = `${

        | 'HLP' // Helpers/Shared Common Code
        | 'DGW' // Data Gateway
        | 'DAA' // DAAS / Data Aggregator and Access Service
        | 'TVC' // Total Vis Connector
        | 'LTC' // Lanter Track 1 Connector
        | 'DTC' // D365 Connector
        | 'DWC' // Data Warehouse Connector
        | 'SHC' // Shipping Connector
        | 'SHU' // Shipping Portal UI
        | 'IAM' // IAM Connector
        | 'L2C' // Lanter Track 2 Connector
        | 'DET' // DET Connector
        | 'API' // API Abstraction Layer
}${singleDigit}${singleDigit}${singleDigit}`;

type singleDigit = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export class FmtpError extends Error {
    errorCode: FmtpErrorCode | undefined;
    name = 'FmtpError';
    memo: string; // This is necessary because message is not an enumerable field on errors and will not be picked up by JSON.stringify. While we are duplicating the data with memo, it is able to persist and bubble up whereas message does not
    constructor({ message, errorCode }: FmtpErrorArgs) {
        super(message);
        Object.setPrototypeOf(this, FmtpError.prototype);
        this.errorCode = errorCode;
        this.message = message;
        this.memo = message;
        this.stack = new Error().stack;
    }
}

// Type guard function for FmtpError
export function isFmtpError(err: unknown): err is FmtpError {
    return (err as FmtpError).name === FmtpError.name;
}
